module.exports = __webpack_public_path__ + "images/aprilia_small8c88f82de150c9910e16c8c82a48fcbb.png";